import { useNavigate } from 'react-router-dom';
import type { FeatureCatalogEntry } from '../../types/auth';

interface DataEditingLandingCardProps {
  feature: FeatureCatalogEntry;
}

function codeToPath(code: string): string {
  return `/${code.replace(/_/g, '-')}`;
}

export function DataEditingLandingCard({ feature }: DataEditingLandingCardProps) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(codeToPath(feature.code))}
      className="block w-full text-left p-6 bg-card rounded-lg shadow hover:shadow-md transition border border-line"
    >
      <h2 className="text-lg font-semibold text-ink mb-2">{feature.displayName}</h2>
      {feature.description && <p className="text-sm text-ink-soft">{feature.description}</p>}
      <span className="inline-block mt-4 text-sm font-medium text-primary-700">Open →</span>
    </button>
  );
}
